import React from 'react';
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from '@headlessui/react';
import { BsChevronDown } from 'react-icons/bs';
import { cn } from '@/utils/cn';

const FilterDropdown = ({
  title,
  children,
  isProPage = false,
}: {
  title: string;
  children: React.ReactNode;
  isProPage?: boolean;
}) => (
  <div className='flex w-full flex-col border-b border-gray-200 lg:w-max lg:border-0'>
    <div className='hidden lg:block'>
      <div
        className={cn(
          'my-3 flex w-full flex-none flex-row items-center justify-between text-base font-bold lg:mt-0 lg:mb-3.5',
          isProPage ? 'text-white' : 'text-slate-700'
        )}
      >
        {title}
      </div>
      <div
        className={cn(
          'mb-8 flex flex-col items-start gap-y-3 text-sm font-medium lg:gap-y-1',
          isProPage ? 'text-white' : 'text-slate-500'
        )}
      >
        {children}
      </div>
    </div>
    <div className='relative block lg:hidden'>
      <Disclosure>
        {({ open }) => (
          <div>
            <DisclosureButton
              className={cn(
                'my-5 flex w-full flex-none cursor-pointer flex-row items-center justify-between text-base font-bold lg:mt-0 lg:mb-3.5',
                isProPage ? 'text-white' : 'text-slate-700'
              )}
            >
              <span>{title}</span>
              <BsChevronDown className={open ? 'rotate-180 transform' : ''} />
            </DisclosureButton>
            <DisclosurePanel
              className={cn(
                'mb-8 flex flex-col items-start gap-y-3 text-sm font-medium lg:gap-y-1',
                isProPage ? 'text-white' : 'text-slate-500'
              )}
            >
              {children}
            </DisclosurePanel>
          </div>
        )}
      </Disclosure>
    </div>
  </div>
);

export default FilterDropdown;
